import { render, staticRenderFns } from "./InactiveScheme.vue?vue&type=template&id=4ff977c0&scoped=true&"
import script from "./InactiveScheme.vue?vue&type=script&lang=js&"
export * from "./InactiveScheme.vue?vue&type=script&lang=js&"
import style0 from "./InactiveScheme.vue?vue&type=style&index=0&id=4ff977c0&prod&lang=scss&scoped=true&"
import style1 from "./InactiveScheme.vue?vue&type=style&index=1&id=4ff977c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff977c0",
  null
  
)

export default component.exports